/**
 * Derived reading metadata (research D6): word count, reading-time estimate, and a
 * display label — all pure functions of the reading `body`. A null body yields a
 * zero count and an em-dash length label.
 */

const WORDS_PER_MINUTE = 200

export function wordCount(body: string | null): number {
  if (!body) return 0
  const trimmed = body.trim()
  if (trimmed === '') return 0
  return trimmed.split(/\s+/).length
}

export function minutes(body: string | null): number {
  const words = wordCount(body)
  if (words === 0) return 0
  return Math.ceil(words / WORDS_PER_MINUTE)
}

export function lengthLabel(body: string | null): string {
  if (!body || body.trim() === '') return '—'
  return `${wordCount(body)} words · ${minutes(body)} min`
}

/**
 * A short plain-text preview for the catalog. Strips any HTML markup, collapses
 * whitespace, and returns the first one or two sentences (capped at `maxChars`),
 * suffixed with an ellipsis when the source text was longer.
 */
export function excerpt(body: string | null, maxChars = 160): string {
  if (!body) return ''
  const text = body
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  if (text === '') return ''

  const sentences = text.match(/[^.!?]+[.!?]+/g)
  let preview = sentences ? sentences.slice(0, 2).join(' ').trim() : text
  if (preview.length > maxChars) {
    preview = preview.slice(0, maxChars).replace(/\s+\S*$/, '').trim()
  }
  return preview.length < text.length ? `${preview}…` : preview
}
